import Chart from "app/components/analytics/shared/Chart/";
import { DateFilter } from "app/components/analytics/shared/DateFilters";
import { Metrics } from "app/components/analytics/shared/type";
import { ChartDataset, ChartOptions as ChartJSOptions } from "chart.js";

type MiniChartMetrics = Pick<Metrics, "metric" | "chartType">;

type Props = MiniChartMetrics & {
  filter: DateFilter;
  branch: string | null | undefined;
  endpoint: string;
  tagString?: string | null;
  groupByTagString?: string | null;
};

interface ChartOptions {
  options: ChartJSOptions;
  data: {
    datasets: Omit<ChartDataset<"bar" | "line">, "data">[];
  };
}

const chartOptions = (metric: Props["metric"]) => {
  const options: ChartOptions = {
    data: {
      datasets: [
        {
          label: metric,
          // @ts-expect-error - border radius is only available in bar chart
          borderRadius: 2,
        },
      ],
    },
    options: {
      scales: {
        // eslint-disable-next-line id-length
        x: {
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
        // eslint-disable-next-line id-length
        y: {
          beginAtZero: true,
          border: {
            display: false,
          },
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      layout: { padding: 1 },
      events: [], // disable all hover/click events for mini chart
    },
  };
  return options;
};

const MiniChart = ({
  filter,
  branch,
  metric,
  endpoint,
  chartType,
  tagString,
  groupByTagString,
}: Props) => (
  <Chart
    height={50}
    width={200}
    filter={filter}
    branch={branch}
    metric={metric}
    endpoint={endpoint}
    options={chartOptions(metric)}
    chartType={chartType}
    tagString={tagString}
    groupByTagString={groupByTagString}
  />
);

export default MiniChart;
